import { CoalitionButton } from "../CoalitionComplements";
import { drawBalance, BalanceTag, getImg } from "./../../utils";
import { cards, chevron_right } from "./../../pngs";
import "./CoalitionHeroBanner.scss";

export const CoalitionHeroBanner = ({
  balance = 0,
  ruleEquivalence = (base) => base * 0.1,
  showEquivalence = true,
  onClickEvent,
}) => {
  return (
    <>
      <div className="landing">
        <div className="background" />
        <div className="description">
          <div className="points">Tus puntos:</div>
          <div className="balance">{drawBalance(balance)}</div>
          {showEquivalence ? (
            <div className="equivalence">
              Valen $
              <BalanceTag bits={ruleEquivalence(balance)} />
            </div>
          ) : null}
          <CoalitionButton
            label="Movimientos"
            klass={`movements ${showEquivalence ? "" : "added"}`}
            onClickEvent={onClickEvent}
          >
            {getImg(chevron_right)}
          </CoalitionButton>
        </div>
        <div className="illustration">{getImg(cards)}</div>
      </div>
    </>
  );
};
